var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextJsIconSeeklogocom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Next.js") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 128,
    cy: 128,
    r: 128
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.6325605%",
    y1: "56.3850422%",
    x2: "83.2279093%",
    y2: "96.0801119%",
    id: "nextjsLinearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "49.9534722%",
    y2: "73.4375%",
    id: "nextjsLinearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000000",
    cx: 128,
    cy: 128,
    r: 128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6336,224.028444 L98.3352889,76.8 L76.8,76.8 L76.8,179.157333 L94.0282311,179.157333 L94.0282311,98.6788978 L199.109689,234.446222 C203.851378,231.273244 208.368356,227.790222 212.6336,224.028444 Z",
    fill: "url(#nextjsLinearGradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#nextjsLinearGradient-4)",
    x: 163.555556,
    y: 76.8,
    width: 17.0666667,
    height: 102.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextJsIconSeeklogocom);
export default __webpack_public_path__ + "static/media/next-js-icon-seeklogo.com.5ed0382970b88314540093c3ece559a7.svg";
export { ForwardRef as ReactComponent };